import {
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_ERROR,
  TOGGLE_NOTIFICATION_MODAL,
  SEND_NOTIFICATION_V2,
  SEND_NOTIFICATION_V2_SUCCESS,
  SEND_NOTIFICATION_V2_ERROR,
} from "./actionTypes";

export const sendNotification = (request) => {
  return {
    type: SEND_NOTIFICATION,
    payload: { request },
  };
};

export const sendNotificationSuccess = () => {
  return {
    type: SEND_NOTIFICATION_SUCCESS,
  };
};

export const sendNotificationError = (message) => {
  return {
    type: SEND_NOTIFICATION_ERROR,
    payload: message,
  };
};

export const sendNotificationV2 = (request) => {
  return {
    type: SEND_NOTIFICATION_V2,
    payload: { request },
  };
};

export const sendNotificationV2Success = () => {
  return {
    type: SEND_NOTIFICATION_V2_SUCCESS,
  };
};

export const sendNotificationV2Error = (message) => {
  return {
    type: SEND_NOTIFICATION_V2_ERROR,
    payload: message,
  };
};

export const toggleNotificationModalAction = () => {
  return {
    type: TOGGLE_NOTIFICATION_MODAL,
  };
};
